const getFormatedPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return null
  let formatedPhoneNumber = `+${phoneNumber.slice(0, 2)}`
  let final = ''
  if (phoneNumber.slice(2, 5) === '800') {
    formatedPhoneNumber = `${formatedPhoneNumber} ${phoneNumber.slice(2)}`
  } else {
    if (phoneNumber.length === 13) {
      final = `${phoneNumber.slice(4, 9)}-${phoneNumber.slice(9)}`
    } else if (phoneNumber.length === 12) {
      final = `${phoneNumber.slice(4, 8)}-${phoneNumber.slice(8)}`
    } else {
      final = phoneNumber.slice(4)
    }
    formatedPhoneNumber = `${formatedPhoneNumber} (${phoneNumber.slice(2, 4)}) ${final}`
  }

  return formatedPhoneNumber
}

export default getFormatedPhoneNumber
